export default {
  ['title']: '赛道简介',
  ['sub-title']: 'CATEGORIES INTRODUCTION'
}
